export const LOGO_URL = "https://customer-assets-lxgj4vgw.emergentagent.net/job_qr-menu-pro-13/artifacts/obijhaql_N%20%2846%29.png";
export const GOLD = "#B2A475";
export const GOLD_LIGHT = "#C7B78F";
export const DARK = "#0B0B0C";
export const SUPERADMIN_EMAIL = "norrissfrank@gmail.com";

